import { render, staticRenderFns } from "./superwordGrouted.vue?vue&type=template&id=f8b403f4&scoped=true"
import script from "./superwordGrouted.vue?vue&type=script&lang=js"
export * from "./superwordGrouted.vue?vue&type=script&lang=js"
import style0 from "./superwordGrouted.vue?vue&type=style&index=0&id=f8b403f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b403f4",
  null
  
)

export default component.exports